export default __webpack_public_path__ + "static/media/BM_RenderCamera_09_BedroomA_02+Interior+Light_Scheme+Bedroom.c47de3d6.jpg";